<template>
	<div class="l-view">
		<img 
			src="/img/backWhite.png" 
			srcset="/img/backWhite@3x.png 3x /img/backWhite@2x.png 2x /img/backWhite.png 1x"
			class="back-icon"
			@click="$router.go(-1)"
		/>
		<div class="l-view__header">
			Likes
		</div>
		<div class="l-view__header-backdrop"></div>
		<RecycleScroller
			class="l-view__list"
			:items="likers"
			:item-size="90"
			key-field="uid"
			v-slot="{item}"
		>
			<UserItem :uid="item" />
		</RecycleScroller>
	</div>
</template>

<script>
	import UserItem from '@/components/UserItem.vue'
	export default {
		name: 'LikersView',
		components: {
			UserItem
		},
		props: {
			postUid: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				post: null
			}
		},
		computed: {
			likers() {
				return this.post?.likers || []
			}
		},
		watch: {
			postUid: {
				immediate: true,
				handler: 'getPost'
			}
		},
		beforeCreate() {
			window.users = {}
		},
		methods: {
			getUsers(ids=[]) {
				return new Promise((resolve) => {

				})
			},
			getPost: async function(uid) {
				// console.log((await this.$DB.db.collection('users').get()).docs.map(doc => Object.freeze(doc.data())))
				this.post = null
				if (!uid) return
				let [post] = (await this.$DB.db.collection('comments').where('uid', '==', uid).get()).docs.map(doc => doc.data())
				// for test users
				// post.likers = ["06526a5f-fb6f-4441-a3b8-fa3633c6713b","0LcYhwqC3gTH323mtTHyqk3VmlI2","0Wn7CfIWDgaAukSh0PGCMKhqpEx2","1ciZuzVC2dVkt4Gjm4MsZPslG413","1vBTeCDT5qcRELiMBF8eM44oy283","2462a719-a17f-4b23-b65b-bb27177c606d","27n6rGXqmtQqdcsTUikB1Xajc9o2","2DbYcca63W5gs9Lac42bFkZNR32","2SaXEibLnTUmjOZH2DjwZfPbvOL2","2Uf98ydMEAMHGjGQ06rroE7s7bt1","3pPkG8GGxUN0kCqVG2ECYWKlLzI2","3xMG31LnN8fMAl7BPbMZItPLR0j2","3z8XkxjdTmd4XEq39B8TBo4piNJ3","428khzmDbkdac5v7MLXXWVpT5Nx1","4N3CLuKkdOvjPBaCkkdOJFlCp3VFpG40Xc8EwQyRKnjw3OfEIr","4bYiRkl3CUMJsnQBWWTYeIFFmXw1","4pwhNb7ooGTO8gJO2SAVqRemNhg2","51NaTauAXLSeY9MCSZk87qK7Rjv2","5FMUpkPg4eOfT9qT73q1uJjdwgf1","5HbJR2JlAzNxokBpg1yN0z5hzKD2","5P9mBm5LWKPuFvDHwBNkTs5eT8S2","6bIz4evT0ASNxY0vNaGyVZ1fBWi2","6d9e00a8-ecf9-4324-9108-b20f1df8d235","6sdkHTj9wWVkI2F0XAAg07rLMCm2","78LJSj0W0zgCo63A0pv7rVg9v6l2","7LPACjFKrZUS8tdvaY0BNKOn7aL2","7dVkeopjaSgReiQNDJ3uAPjjXqJ2","7mNszvrsPOXDIo69bKGX8CHotZZ2","7oVOvJLDo9aqSKdGhjtmFqryRIQ2","7uFtcEVNFlZFnqONSgy8VOLQqmF2","97BlAU6FSjTAKWgfPhrUbA5tjpo2","9J4KYtwJRGXBBgytsUktnvKyJmT2","9RWCYNLiXHVmoJt9dBvQhWAdB113","AGRpB6SaDaXenG5lVm77rUkfcxo2","APzNf4vHquT463Za1pkFm1a9R6u2","AYO6eAFxPgUj30OnZq2gXpX3PcNw5jy1PSEDSfHrYVhVyJeqia","AZT30uU61UMXSCxIMqYTvWaKSAV2","AuAs5LIzObOlCXvWW6P4widV12r1","B5eJrV1UMAISmd42LXhRoYtonhmUQH3xA392p2FIVjlsVtjfUG","BAzVQrfF0TcoRsuJHDbRzRMv33K2","CAej478GV3ef7iBrGDcrztmxxsQ2","Czsb9J9XwXIOpdrp5entZoqiQDikwUFT2jAGptYEqw2JAmD0CX","Dlq5nN6SmmQI0y8k9xfuHKYmGk02","DorLBTaV4BUoPw2Uo4frLQohjGG3","Ds4GO7en6MRR236Fvcj6PD7J0jj1","EFaLNySKmzQzG5t6VlDwF8nxfTb2","EHSB6QO2vqP4rEbalGqbrBVJa253","EbocCB0QvUXdqvyID30KEQmOyqB3","EgSfZSzkV3gveZUiyh8TgbHDNmK2","EvZtaHgdQgsJX58eVmd2s3ud4OKwU6scrFMTNUQvdGVoeugiBk","F5CMFcBM9BZfFHlIfBBUzIWYhA03","FcpVsaokSvXR45wTUhm9WkwGHUC2","Fg7Xyo8HNPM0WHojF8r0BREAnHL2","FlvkKlsOIefb3zomBXBuYox7J4M2","G3WTiwazZOXCvrb5Z4MFXb8hCOj1","G3anIMzpP0gRBoQS5pdj9bNhHgR2","G3lnNozJLuOPYXO2HF3ERVV1CuJ2","GOQ1HGagOIaO6JjvySKlniuAIoW2","HH3sVBlnfSdJlMNEDFz4nwx2dr12","HLx3qdAmwQbD4l4hEBgOisEFK7K2","HVseFRgV3Xb6UWaD838WTBFJwqK2","HsBsFS1Q27Sw9uGaWEPETnzdFZl2","IKRso7OFOxOmERbT4ojyLWTwjLw1","IVDvojN2wxbsOGyIYTcmmznKKFA2","IYbtYbUlUqSfbUegObRT0hd2znb2","Imczrm4eEpW2XEzn44JLjVSSNPK2","JIsnKofWD9fb3skedCpXZ9Ld2QF3","JvRwwVVYWBZngLxQGzqeOI8UBqU2","KEQzio2ZQJhXIxs4v8LL4XGh9953","KMh0yvM76fW1869wDeIFHF4lDHJ2","KsHWYlg94MOtQiRTBwUTp5uS0y62","L5fJXL4GrgQIPIFe5iw67gUghgI2","MI0YBF59wRA8eCQmllp9jajBSwxKe9ledC4JwEsIKoNbRVBrRt","ML4J5qIjIlYtXxnPhIQ3rwPbiFp2","MZBflj40sJSWXg1pvHXpyjJoaSU2","MrKadxwAW7UM380gK5wD0CRknv42","OdlfTNNo4HRPUXyzsaNr059OVfL2","OvEG5njTtpQbH3pDzjqRLQ5XXah1","P62SkSeBucNjUnjlHe4JT0VaLdo2","QZSsjxxExjRaZqCC91a1hu63v0p2","Qap986ieU8Qip6SXmceRubPJELm1","Qo3RDJheq5RR05s0AQ12pwoHTE9UdQj7krkTG7xus5dmrU9DeA","R0Z1gb3Fw0QpF4zBPR9xdR9RUyf2","RA5JBgRlhEZVSlXH5i7KHO082cd2","RGMczq26MEbzZzL9JD38FqZQkcD3","RHCNbEboK5c3KwXjB7MFdCHNHyF3","RqYT1tu5v9MfTO3BWP5ux4pisOl2","S2Xetghq6qVc24o6rumKTQjMpwt1","TH8sRByhuGgt9hhVu9CnSbEx1qB3","TIntPnBCDPSOdzMCppGe7NjINJp2","V9TJaYj8cScMOgs9RzRnbJPxL8m1","VDVjucG19bedOpGGvApNbx6LWWr1","VbIi2IenlpZfJO7z5zNPhJItFbT2","W5ppIpuG04TdiIba1NQnjh4rr962","WaXvepnGtvMGhPpAXtUonMxIUNq1","WjjNMRKAm8gwX4fFjXty0dYiZ8x1","X22pNZo7YvSXdTq9foKsMU6C1cV2","XWDtadaiARTpPK2cTHC8jXQIhjD3","Y4xp6rjhNtgnX5tPKMqmmi52o5i2","Y81hsIj61UeMtkMjD2rRHpX26O42"]			
				this.post = post
				
			}
	
		}
	}
</script>

<style lang="scss">
	.l-view {
		position: fixed;
		top: 0;
		bottom: 0;
		width: 100%;
		z-index: 105;
		background: $black;

		.back-icon {
			left: 20px;
    		top: 20px;
			position: absolute;
			height: 30px;
			width: 30px;
			z-index: 2;
		}
		&__header {
			@include pos-centered-h;
			top: 20px;
			@include font(17, 22, 600);
			color: $white;
			z-index: 2;

			&-backdrop {
				position: absolute;
				background: rgba(22, 22, 22, 0.75);
				top: 0;
				left: 0;
				right: 0;
				height: 60px;
				z-index: 1;
				backdrop-filter: blur(10px);
			}
		}

		&__list {
			margin-top: 60px;
			height: calc(100% - 60px);
			width: 100%;
			// overflow-x: hidden;
			// overflow-y: scroll;

			&-item {
				width: 100%;
				height: 90px;
				background: $darkGreyTwo;
				border-bottom: 1px solid rgb(90, 90, 94);
				@include flex(row, flex-start, center);
				padding-left: 16px;
				position: relative;

				// &:first-child {
				// 	margin-top: 60px;
				// }
				// &:last-child {
				// 	margin-bottom: 60px;
				// 	border-bottom: none;
				// }

				&__avatar {
					width: 93px;
					height: 70px;
					object-fit: cover;
					border-radius: 5px;
				}

				&__info {
					height: 48px;
					margin-left: 16px;
					width: 100%;

					&-name {
						color: $white;
						@include font(18, 24, 500);
						text-align: left;
						@include textTruncate(85%);
					}

					&-zodiac {
						margin-top: 8px;
						@include flex(row, flex-start, center);
						img {
							width: 16px;
   							height: 16px;
						}

						&__text {
							@include font(12, 14, 600);
							margin-left: 8px;
							color: $white;
							text-transform: uppercase;
						}
					}
				}

				&__right {
					@include pos-centered-v;
					right: 30px;
				}
			}
		}
	}
</style>